// import {Trans} from '@lingui/macro';
import {Divider, Snackbar} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import Signature from 'components/Editors/Signature';
import {Content, Title} from 'components/forms/index';
import useUser from 'components/GenericsHooks/useUser';
import {i18n2} from 'features/i18n/i18n';
import {Form, Formik} from 'formik';
import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import {Redirect} from 'react-router-dom';
import useCloneCourse from '../hooks/useCloneCourse';

interface CloneCourseProps {
  open: boolean;
  idCourse: number;
  name: string;
  handleClose: () => void;
  version: number;
  typeCourse: string;
}

function CloneCoursePopup({
  open,
  idCourse,
  name,
  handleClose,
  version,
  typeCourse,
}: CloneCourseProps) {
  const [message, setMessage] = useState({
    text: '',
    open: false,
    succesful: false,
  });
  const [redirect, setRedirect] = useState(false);
  const [idNewCourse, setIdNewCourse] = useState();
  const userName = useUser();
  const cloneCourse = useCloneCourse();
  const dispatch = useDispatch();
  const url = '/Course';

  const submit = (
    values: any,
    formikBag: {setSubmitting: (arg0: boolean) => void},
  ) => {
    values = {
      ...values,
      user: userName,
      idCourse: idCourse,
    };
    cloneCourse(values)
      .then((response) => {
        if (response.ok) {
          response.json().then((data: any) => {
            setIdNewCourse(data);
            dispatch({type: 'SAVE_ID_COURSE', payload: data});
          });
          setMessage({
            text: i18n2._('Curso clonado exitosamente'),
            open: true,
            succesful: true,
          });
        } else {
          response
            .text()
            .then((message: string) =>
              setMessage({text: message, open: true, succesful: false}),
            );
          formikBag.setSubmitting(false);
        }
      })
      .catch((error) => console.log(error));
  };
  return (
    <>
      <Dialog open={open}>
        <Title onClose={handleClose} title={i18n2._('Clonar curso')} />
        <Divider />
        <Content
          text={
            i18n2._('Está a punto de clonar el curso') + ` ${name} v.${version}`
          }
        />
        <Formik
          initialValues={{
            reason: '',
            user: userName,
            pass: '',
          }}
          onSubmit={submit}
          validateOnChange
          enableReinitialize
        >
          {(formikProps) => {
            return (
              <Form style={{padding: 15}}>
                <Signature
                  user={userName}
                  customPadding={'1%'}
                  errors={formikProps.errors}
                  touched={formikProps.touched}
                />
                <DialogActions>
                  <Button
                    autoFocus
                    onClick={() => handleClose()}
                    className="red-text"
                  >
                    {i18n2._('Cancel')}
                  </Button>
                  <Button
                    type="submit"
                    color="primary"
                    disabled={formikProps.isSubmitting}
                  >
                    {i18n2._('Accept')}
                  </Button>
                </DialogActions>
              </Form>
            );
          }}
        </Formik>
      </Dialog>
      {redirect && (
        <Redirect
          to={{
            pathname: url,
            state: {id: idNewCourse, type: false, typeCourse: typeCourse},
          }}
        />
      )}
      <Snackbar
        open={message.open}
        autoHideDuration={1000}
        onClose={() =>
          message.succesful
            ? setRedirect(true)
            : setMessage({...message, open: false})
        }
        message={i18n2._(message.text ? message.text : '')}
      />
    </>
  );
}

export default CloneCoursePopup;
